import React from 'react';
import "../Css/PreviewPage.scss";


function PreviewPage(props) {


    return (
        <div className={`PreviewPageContainer ${props.isPreviewIsOver ? "fadeOut" : ""}`}>
            <div className="backgroundFilter"></div>
            {!props.isPreviewIsOver &&
                <div className="stationLogo">
                </div>
            }
            {!props.isPreviewIsOver &&
                <div className="container">
                    <span className="circle"></span>
                    <span className="circle"></span>
                    <span className="circle"></span>
                    <span className="circle"></span>
                </div>
            }
            <h1>
                <p className="type-animation animating">
                    <span>طراحی</span>&nbsp;
                    <span>و</span>&nbsp;
                    <span>اجرا</span>&nbsp;
                    <span>,</span>&nbsp;
                    <span>ویرا</span>&nbsp;
                    <span>تک</span>&nbsp;
                    <span>آروند</span>&nbsp;
                    <span>آریا</span>&nbsp;
                </p>
                <div className="logo">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 250 250">
                        <g id="Layer_5" data-name="Layer 5">
                            <path className="cls-1"
                                  d="m156.15,85.11c1.1,0,1.88,1.09,1.51,2.13l-53.31,150.57-3.22,8.81c-.29.77-.85,1.39-1.55,1.75l-9.92.03-33.11.11-9.77.03c-.37-.25-.56-.73-.39-1.19l3.41-9.37,53.29-151.26c.3-.86,1.12-1.44,2.03-1.44l7.92-.02c1.1,0,1.88,1.09,1.51,2.12l-52.62,149.57c-.17.48.19.99.7.99l29.75-.09c.32,0,.59-.2.7-.49l53.09-150.77c.3-.86,1.12-1.44,2.03-1.44l7.97-.02h0Z"/>
                        </g>
                        <g id="Layer_4" data-name="Layer 4">
                            <path className="cls-1"
                                  d="m186.25,6.46l-11.84,33.45c-.31.86-1.12,1.44-2.03,1.44l-8.05.02c-1.1,0-1.88-1.09-1.51-2.12l8.01-22.76c.5-1.36-.51-2.79-1.95-2.79h-26.95c-.88-.01-1.66.53-1.95,1.35l-8.79,25c-.3.86-1.12,1.44-2.03,1.44l-7.9.02c-1.1,0-1.88-1.09-1.51-2.12l11.97-33.95c.62-1.69,2.23-2.82,4.03-2.82l47.84.02c1.98,0,3.36,1.97,2.67,3.83h0Z"/>
                        </g>
                        <g id="Layer_3" data-name="Layer 3">
                            <path className="cls-1"
                                  d="m82.83,108.14l-11.09,31.2c-.37.98-1.69,1.13-2.27.25L10.93,50.39c-.55-.85.06-1.97,1.07-1.97h30.91c1.35,0,2.6.68,3.34,1.81l36.29,55.39c.49.75.59,1.69.28,2.52h0Z"/>
                        </g>
                        <g id="Layer_2" data-name="Layer 2">
                            <path className="cls-1"
                                  d="m230.93,78.18s-51.01,158.73-54.98,170.41c-.14.4-.52.68-.95.68-4.3.02-27.09.09-32.14.11-.64,0-1.23-.31-1.59-.83-3.09-4.53-17.16-25.84-17.16-25.84-.54-.84-.65-1.89-.31-2.82l11.39-31.65c.37-.99,1.7-1.14,2.27-.25l14.52,22.51c.36.55,1.19.44,1.39-.18l41.87-129.72c.37-1.14-.48-2.3-1.68-2.3l-105.73.35c-1.23,0-2.11-1.2-1.73-2.37l8.25-25.55c.42-1.3,1.63-2.18,2.99-2.19l138.27-.45c2.49,0,4.25,2.41,3.49,4.78l-8.17,25.3h0Z"/>
                        </g>
                    </svg>
                </div>
            </h1>
        </div>
    );
}

export default PreviewPage;
